"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resumableSignUpEmail = resumableSignUpEmail;
/** The address to resume the code step for, or null to show the form. */
function resumableSignUpEmail(signUp, rememberedId) {
    if (!signUp?.id || !rememberedId || signUp.id !== rememberedId)
        return null;
    if (signUp.status !== "missing_requirements")
        return null;
    if (!signUp.unverifiedFields?.includes("email_address"))
        return null;
    return signUp.emailAddress || null;
}
//# sourceMappingURL=signupResume.js.map